import { render } from "./landingfooter.vue?vue&type=template&id=401a8fa0"
import script from "./landingfooter.vue?vue&type=script&lang=js"
export * from "./landingfooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__